import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';

import { BackButton } from '../../components/Button';
import { DriverParingForm } from '../../components/Forms';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';
import { CONFIG } from '../../utils/constants';

export default function DriverParing({ title, subtitle }) {
  const dispatch = useDispatch();
  const driver = useSelector((state) => state.driver);
  const employee = useSelector((state) => state.employee);
  const vehicle = useSelector((state) => state.vehicle);

  const history = useHistory();
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({});

  useEffect(() => {
    dispatch(actions.vehicleAll({ size: CONFIG.infiniteLimit }));
    dispatch(actions.employeeAll({ size: CONFIG.infiniteLimit }));
    return () => {};
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      console.log(data);
      await dispatch(actions.driverCreate(data));
      alert('สำเร็จ');
      dispatch(actions.driverAll({}));
      history.goBack();
    } catch (error) {
      alert(`การจับคู่คนขับรถไม่สำเร็จ ${error?.message}`);
      console.log(error);
    }
  };

  if (employee.isLoading || vehicle.isLoading) {
    return <Loading />;
  }
  if (
    !employee.isLoading &&
    employee.isCompleted &&
    !vehicle.isLoading &&
    vehicle.isCompleted
  ) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <DriverParingForm
                errors={errors}
                employee={employee}
                vehicle={vehicle}
                driver={driver}
                control={control}
                Controller={Controller}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}

DriverParing.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

DriverParing.defaultProps = {
  title: '',
  subtitle: '',
};
